module.exports = __webpack_public_path__ + "static/media/38.a1fade24.jpg";